export default __webpack_public_path__ + "static/lydec-6222ad62e3a5baf410ac77b6296f01b6.png";